import Turtle from 'assets/imgs/portfolio/turtles.png';
import MetaVS from 'assets/imgs/portfolio/metavs.png';
import Baboon from 'assets/imgs/portfolio/baboon.png';
import Goats from 'assets/imgs/portfolio/goats.png';
import Teddy from 'assets/imgs/portfolio/teddy.png';
import Fallen from 'assets/imgs/portfolio/fallenFlower.png';
import CrazyApes from 'assets/imgs/portfolio/crazyApes.png';
import Samurai from 'assets/imgs/portfolio/samuraiSociety.png';
import Boobies from 'assets/imgs/portfolio/boobies.png';
import Fruity from 'assets/imgs/portfolio/fruity.png';
import Pigeonhead from 'assets/imgs/portfolio/pigeonhead.png';
import Frogs from 'assets/imgs/portfolio/frogs.png';
import Landz from 'assets/imgs/portfolio/landz.png';
import OneMintSpot from 'assets/imgs/portfolio/one-mint-spot.png';
import LiberTV1 from 'assets/imgs/portfolio/liber-t-v1.png';
import LiberTV2 from 'assets/imgs/portfolio/liber-t-v2.png';
import Monalisa from 'assets/imgs/portfolio/monalisa.png';
import Quickprove from 'assets/imgs/portfolio/quickprove.png';
import { IPortfolioData } from 'models/portfolio';
import TheKingDomArea from 'assets/imgs/portfolio/the-kingdom-area.png';
import FexApp from 'assets/imgs/portfolio/fex-application.png';

export const portfolioData: IPortfolioData[] = [
  {
    siteName: 'FEX',
    siteUrl: 'https://staging.firmexplore.de/',
    description: 'Web Application with client and admin pages',
    preview: FexApp,
    badge: ['Vue2', 'Tailwind'],
    githubUrl: '',
    previewTarget: '_blank',
  },
  {
    siteName: 'The Kingdom Area',
    siteUrl: 'https://thekingdomarea.com/',
    description: 'Web Application with client and admin pages',
    preview: TheKingDomArea,
    badge: ['React', 'Tailwind', 'NodeJS', 'MongoDB', 'Firebase', 'Vercel'],
    githubUrl: '',
  },
  {
    siteName: 'Quickprove',
    siteUrl: 'https://nhanlnt-96.github.io/quickprove/',
    description: 'Responsive site using HTML/CSS and Tailwind',
    preview: Quickprove,
    badge: ['HTML', 'CSS', 'Tailwind'],
    githubUrl: 'https://github.com/nhanlnt-96/quickprove',
  },
  {
    siteName: 'Monalisaverse',
    siteUrl: 'https://monalisa-c5555.web.app/',
    description: 'Integrate admin page to current site.',
    preview: Monalisa,
    badge: ['React', 'Redux', 'NodeJS', 'Express', 'MySql', 'Firebase'],
    githubUrl: 'https://github.com/nhanlnt-96/monalisa-site-builder',
  },
  {
    siteName: 'LiberT (v1)',
    siteUrl: 'https://site-builder-5e29c.web.app/',
    description:
      'Create landing page with admin page to edit landing page content',
    preview: LiberTV1,
    badge: ['React', 'Redux', 'NodeJS', 'Express', 'MySql', 'Firebase'],
    githubUrl: 'https://github.com/nhanlnt-96/site-with-builder',
  },
  {
    siteName: 'SpaceTurtles',
    siteUrl: 'https://nft-landing.web.app/',
    description: `Create landing page using ReactJS`,
    preview: Turtle,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/turtle-landing-page',
  },
  {
    siteName: 'MetaVs',
    siteUrl: 'https://metavs-33c4c.web.app/',
    description: `Create landing page using ReactJS`,
    preview: MetaVS,
    badge: ['React', 'Redux'],
    githubUrl: 'https://github.com/nhanlnt-96/metavs-landing-page',
  },
  {
    siteName: 'Babbling Baboon',
    siteUrl: 'https://baboon-page.web.app/',
    description: `Create landing page using ReactJS`,
    preview: Baboon,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/baboon-landing-page',
  },
  {
    siteName: 'Dope Goats',
    siteUrl: 'https://dope-goats.web.app/',
    description: `Create landing page using ReactJS`,
    preview: Goats,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/goats-landing-page',
  },
  {
    siteName: 'Teddy Gang CLub',
    siteUrl: 'https://teddy-gang.web.app/',
    description: `Create landing page using ReactJS`,
    preview: Teddy,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/teddy-gang-landing-page',
  },
  {
    siteName: 'Fallen Flower',
    siteUrl: 'https://fallen-flower.web.app/',
    description: `Create landing page using ReactJS`,
    preview: Fallen,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/fallen-flower-landing',
  },
  {
    siteName: 'Crazy Apes Club',
    siteUrl: 'https://crazy-apes.web.app/',
    description: `Create landing page using ReactJS`,
    preview: CrazyApes,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/crazy-apes-landing',
  },
  {
    siteName: 'Boobies',
    siteUrl: 'https://boobies-bb767.web.app/',
    description: `Create landing page using ReactJS`,
    preview: Boobies,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/boobies-landing',
  },
  {
    siteName: 'Fruity Fools',
    siteUrl: 'https://fruity-fools.web.app/',
    description: `Create landing page using ReactJS`,
    preview: Fruity,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/fruity-fools-landing',
  },
  {
    siteName: 'Samurai Society',
    siteUrl: 'https://samurai-society.web.app/',
    description: `Create landing page using ReactJS`,
    preview: Samurai,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/samurai-society',
  },
  {
    siteName: 'Pigeonhead',
    siteUrl: 'https://pigeonhead.web.app/',
    description: `Create landing page using ReactJS`,
    preview: Pigeonhead,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/pigonhead',
  },
  {
    siteName: 'Frogs',
    siteUrl: 'https://frogs-landing.web.app/',
    description: `Create landing page using ReactJS`,
    preview: Frogs,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/baby-spell-frog',
  },
  {
    siteName: 'Landz',
    siteUrl: 'https://landz-47180.web.app/',
    description: `Create landing page using ReactJS`,
    preview: Landz,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/landz-landing',
  },
  {
    siteName: 'One Mint Spot',
    siteUrl: 'https://landz-v2.web.app/',
    description: `Create landing page using ReactJS`,
    preview: OneMintSpot,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/one-mint-spot',
  },
  {
    siteName: 'LiberT (v2)',
    siteUrl: 'https://libert-fdab0.web.app/',
    description: `Create landing page using ReactJS`,
    preview: LiberTV2,
    badge: ['React'],
    githubUrl: 'https://github.com/nhanlnt-96/liberT-v2',
  },
];
